import { __assign } from "tslib";
import React from 'react';
import { Card } from '@tencent/tea-component';
;
/**
 * 卡片头部 `<Card.Header>` 属性集合。
 */
export function BuyCard(props) {
    return (React.createElement(Card, __assign({}, props)));
}
BuyCard.Header = Card.Header;
BuyCard.Body = Card.Body;
BuyCard.Footer = Card.Footer;
//# sourceMappingURL=BuyCard.js.map